import z from "zod";

import { SCROLL_AREA_FADES } from "./constants";

const booleanAttribute = z
  .string()
  .optional()
  .transform((value) => value !== undefined && value !== "false");

export const scrollAreaDataSchema = z.object({
  fade: z
    .enum(SCROLL_AREA_FADES)
    .optional()
    .transform((value) =>
      value === undefined || value === "false"
        ? false
        : value === "true"
          ? true
          : value,
    ),
  expandOnHover: booleanAttribute,
  alwaysVisible: booleanAttribute,
});

export type ScrollAreaDataProps = z.infer<typeof scrollAreaDataSchema>;
